export function formatDate(date: string | undefined) {
    if (!date) return "-";
    const ms = Date.parse(date);
    if (Number.isNaN(ms)) return "-";
    return new Date(ms).toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hourCycle: 'h24',
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'shortOffset',
    });
}